<template>
  <div :class="['dh-psy-diary', 'article-feature', {
      'dh-psy-diary--left': align === 'left',
      'dh-psy-diary--right': align === 'right'
    }]">
    <div class="dh-psy-diaryWrapper">
      <h4>{{ title }}</h4>
      <p v-if="subtitle" class="dh-psy-diary__subtitle">{{ subtitle }}</p>
      <p>
        <span>
          {{ content }}
        </span>
      </p>
    </div>
  </div>
</template>

<style scoped lang="postcss">
  .dh-psy-diary > * {
    float: none;
  }

  .dh-psy-diary {
    display: flex;
    width: 90%;
    max-width: 1000px;
    padding: 0;
    font-weight: 300;
    font-size: 0.9em;
    line-height: 1.6;
    font-family: 'NRK Etica Slab';
    padding: 0 1em;
    box-sizing: border-box;

    @media (min-width: 800px) {
      font-size: 1em;
      padding: 0;
    }

    &.dh-psy-diary--right {
      justify-content: flex-end;
    }

    &.dh-psy-diary--start {
      justify-content: flex-end;
    }

    & .dh-psy-diaryWrapper {
      float: none;
      margin: 0;
      box-sizing: border-box;
      max-width: 90vw;
      width: 90%;
      max-width: 590px;

      display: inline-block;
      border-radius: 5px;
    }

    & h4 {
      text-align: center;
      margin: 0 0 2em;
      font-weight: 100;
      text-transform: uppercase;
      font-size: 1em;
    }

    & .dh-psy-diary__subtitle {
      color: #9f9f9f;
    }

    & p {
      box-sizing: border-box;
      width: 540px;
      max-width: 100%;
      margin-top: 10px;
      margin-bottom: 0;
      font-size: 0.9em;
      line-height: 1.6;
      background: linear-gradient(to bottom, #ffffff00 0%, #ffffff00 98%, #ddd 98%);
      background-size: 100% calc(0.9em * 1.6 + 2px);
    }

    & .dh-psy-diary__subtitle {
      background: none;
    }
  }

  .dh-psy-diary--left .dh-psy-diaryWrapper {
    & h4 {
      padding-left: 30px;
    }
    & p {
      margin-left: auto;
      margin-right: 0;
    }
  }

  .dh-psy-diary--right .dh-psy-diaryWrapper {
    & h4 {
      padding-left: 30px;
      margin-left: auto;
    }

    & p {
      margin-right: auto;
      margin-left: 0;
    }
  }
</style>

<script>
export default {
  props: {
    align: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    inverse: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
